export default __webpack_public_path__ + "static/media/IconInstagram.7badf64c.svg";